/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SidebarBlogue.css';
import fetch from '../../core/fetch';
import { Link } from 'react-router';
import CategoriesSidebar from '../../components/CategoriesSidebar';
import PromotionsSidebar from '../../components/PromotionsSidebar';
import InfolettreSidebar from '../../components/InfolettreSidebar';
import ContactSidebar from '../../components/ContactSidebar';

function SidebarBlogue() {
    return (
        <div className={s.root}>
            <CategoriesSidebar />
            <InfolettreSidebar />
            <ContactSidebar />
        </div>
    );
}

export default withStyles(s)(SidebarBlogue);



// WEBPACK FOOTER //
// ./components/SidebarBlogue/SidebarBlogue.js